<template>
  <div class="pt-3">
    <Stepper active-step="3" />
    <GiftDelivery v-if="giftData.isGift" />
    <MailDelivery v-else />
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';
  import Stepper from './Stepper';
  import GiftDelivery from '../gift/GiftDelivery';
  import MailDelivery from './MailDelivery';

  export default {
    components: {
      MailDelivery,
      GiftDelivery,
      Stepper,
    },
    computed: {
      ...mapGetters({
        giftData: 'GET_GIFT_DATA'
      })
    }
  }
</script>

<style scoped lang="scss">
  .delivery {
    &-wrapper {
      display: flex;
      justify-content: center;
    }
    &-method {
      width: 240px;
      border: 1px solid #000;
      margin: 0 1rem;
    }
  }

  textarea.form-control {
    min-height: 180px;
  }
</style>
